import { firestoredb } from "../components/firebase";
import { collection, addDoc } from "firebase/firestore";
import blenny_mint_contractABI from "../abi/blenny-mint.json";
import { toast } from "react-toastify";
import Web3 from "web3/dist/web3.min.js";
import { useEffect } from "react";

// const alchemyKey = process.env.REACT_APP_ALCHEMY_KEY;
// const { createAlchemyWeb3 } = require("@alch/alchemy-web3");
// const web3 = createAlchemyWeb3(alchemyKey);

// const web3 = new Web3(window.ethereum);
// const web3 = new Web3("https://chaotic-autumn-grass.bsc-testnet.discover.quiknode.pro/3aafa5251973313d291107140f1b0e11d4d845cc/");
// require("dotenv").config();
const blenny_mint_contractAddress = process.env.REACT_APP_BLENNY_MINT_ADDRESS;

var allData = [];
let mintedPlots = [{ mintedPlote: 1 }];

export const onMint = async (plotID) => {
  const web3 = new Web3(window.ethereum);

  if (plotID == "" || plotID == null || plotID == undefined) {
    toast("Invalid Plot id", {
      toastId: "customId",
    });
  } else {
    //Blenny Mint Contract
    window.blenny_contract = await new web3.eth.Contract(
      blenny_mint_contractABI,
      blenny_mint_contractAddress
    );

    try {
      // console.log(window.blenny_contract.methods);
      const txHash = await web3.eth.sendTransaction({
        to: blenny_mint_contractAddress, // Required except during contract publications.
        from: window.ethereum.selectedAddress, // must match user's active address.
        // value: web3.utils.toHex(nftPriceTemp),
        data: window.blenny_contract.methods.safeMint(plotID).encodeABI(), //make call to buy box
      });
      await addDoc(collection(firestoredb, "mintedPlots"), {
        plotid: plotID,
        minterAddress: window.ethereum.selectedAddress,
        mintDate: new Date(),
      })
        .then(async (docRef) => {
          window.location.reload();
          return true;
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    } catch (error) {
      console.log("Error While Minting: ", error);
      toast("Error While Minting: Please Connect Metamask", error);
    }
  }
};
export const GetAllTokens = async () => {
  // console.log(web3.eth);
  //Blenny Mint Contract
  const web3 = new Web3("https://chaotic-autumn-grass.bsc-testnet.discover.quiknode.pro/3aafa5251973313d291107140f1b0e11d4d845cc/");
  window.blenny_contract = await new web3.eth.Contract(
    blenny_mint_contractABI,
    blenny_mint_contractAddress
  );
  // console.log(window.blenny_contract);
  try {
    // const allData = await window.blenny_contract.methods
    //   .GetAllTokenIds()
    //   .call();
    // console.log(allData);
    // mintedPlots = [];
    mintedPlots = [];
    const allData = await window.blenny_contract.methods
      .AllTokenDetails()
      .call();

    mintedPlots = allData;

    // for (let index = 0; index < allData.length; index++) {
    //   const token = await window.blenny_contract.methods
    //     .tokenURI(allData[index])
    //     .call();

    //   // console.log(token);
    //   const owner = await window.blenny_contract.methods
    //     .GetAddress(allData[index])
    //     .call();

    // mintedPlots.push({ mintedPlot: token, owner: owner });
    // }
    return mintedPlots;

    // await addDoc(collection(firestoredb, "mintedPlots"), {
    //   plotid: plotID,
    //   minterAddress: window.ethereum.selectedAddress,
    //   mintDate: new Date(),
    // })
    //   .then(async (docRef) => {
    //     window.location.reload();
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  } catch (error) {
    console.log("Error While receiving Data: ", error);
    return [];
    toast("Error While receiving Data: ", error);
  }
};
